import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DenialCategoryComponent } from './denial-category.component';
import { AutoCompleteDenialCodeModule } from 'app/utils/auto-complete-denial-code/auto-complete-denial-code.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Trip2ThemeModule } from 'app/trip2-theme/trip2-theme.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    Trip2ThemeModule,
    AutoCompleteDenialCodeModule
  ],
  declarations: [DenialCategoryComponent],
  exports: [DenialCategoryComponent]
})
export class DenialCategoryModule { }



// WEBPACK FOOTER //
// ./src/app/utils/denial-category/denial-category.module.ts